<div class="buildings-option-container" (click)="$event.stopPropagation()">
  <div class="header-container">
    <div class="title">
      {{ 'module.shared.buildingsOption.titleHeaderText' | translate }}
    </div>
    <div class="information">
      <div class="information-icon"><span class="fa fa-info-circle"></span></div>
      <div class="information-content">
        {{ 'module.shared.buildingsOption.informationContentText' | translate }}
      </div>
    </div>
  </div>

  <mat-tab-group [@.disabled]="true" [selectedIndex]="0">
    <mat-tab *ngIf="!!authService.permissions.BUILDING_TYPE_UPDATE && !!authService.permissions.BUILDING_LOCATION_UPDATE">
      <ng-template mat-tab-label>
        <div class="tab-container">
          <span>{{ 'module.shared.buildingsOption.tabLabelFirstText' | translate }}</span>
          <div *ngIf="((buildingsWithNoCoordinatesAndType | async)?.length || 0) > 0; else identifiedBldgs" class="tab-count">
            {{ (buildingsWithNoCoordinatesAndType | async)?.length }}
          </div>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <app-gps-and-type-buildings-option
          *ngIf="((buildingsWithNoCoordinatesAndType | async)?.length || 0) > 0; else noData"
          [data]="buildingsWithNoCoordinatesAndType | async"
          (selectEvent)="onSelect($event)"
        ></app-gps-and-type-buildings-option>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="!!authService.permissions.BUILDING_LOCATION_UPDATE">
      <ng-template mat-tab-label>
        <div class="tab-container">
          <span>{{ 'module.shared.buildingsOption.tabLabelSecondText' | translate }}</span>
          <div *ngIf="((buildingsWithNoCoordinates | async)?.length || 0) > 0; else identifiedBldgs" class="tab-count">
            {{ (buildingsWithNoCoordinates | async)?.length }}
          </div>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <app-gps-and-type-buildings-option
          *ngIf="((buildingsWithNoCoordinates | async)?.length || 0) > 0; else noData"
          [data]="buildingsWithNoCoordinates | async"
          (selectEvent)="onSelect($event)"
        ></app-gps-and-type-buildings-option>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="!!authService.permissions.BUILDING_TYPE_UPDATE">
      <ng-template mat-tab-label>
        <div class="tab-container">
          <span>{{ 'module.shared.buildingsOption.tabLabelThirdText' | translate }}</span>
          <div *ngIf="((buildingsWithNoType | async)?.length || 0) > 0; else identifiedBldgs" class="tab-count">
            {{ (buildingsWithNoType | async)?.length }}
          </div>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <app-gps-and-type-buildings-option
          *ngIf="((buildingsWithNoType | async)?.length || 0) > 0; else noData"
          [data]="buildingsWithNoType | async"
          (selectEvent)="onSelect($event)"
        ></app-gps-and-type-buildings-option>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <ng-template #identifiedBldgs
    ><div class="check-button"><span class="fa fa-check-circle success" aria-hidden="true"></span></div
  ></ng-template>

  <ng-template #noData>
    <div class="no-data">Keine weitere Handlung notwendig</div>
  </ng-template>
</div>
